export const CSRF_TOKEN = $("meta[name='csrf-token']").attr("content");
export const URL_PREFIX = window.URL_PREFIX;
export const MOBILES = window.matchMedia("(max-width: 767px)");
export const MB_SIZE = 1048576;

export const SITE_NAME = window.SITE_NAME;
export const SITE_STORAGE_VERSION = window.SITE_STORAGE_VERSION || "1.0";

/**
 * Time constants
 * @type {Object}
 */
export const TIME = {
	FADE: {
		DEFAULT: 300,
		SHORT: 100,
	},
	THROTTLE: 100,
	DEBOUNCE: 100,
};
